export default __webpack_public_path__ + "static/media/h-portfolio-fhm.69f8e3ab.webp";